import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { pipe } from 'rxjs';
import { take } from 'rxjs/operators';
import { SSOApiService } from 'src/app/_core/api/sso-api.service';
import { AuthService } from 'src/app/_core/services/auth.service';
import { SpinnerOverlayService } from 'src/app/_core/services/common/spinner-overlay.service';

@Component({
  selector: 'app-auth-return',
  templateUrl: './auth-return.component.html',
  styleUrls: ['./auth-return.component.scss']
})
export class AuthReturnComponent implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private ssoService: SSOApiService,
    private spinner: SpinnerOverlayService
  ) { }

  ngOnInit(): void {

    var token = this.route.snapshot.queryParamMap.get('token')
    var redirectUrl = this.route.snapshot.queryParamMap.get('redirect')

    // console.log('token: ' + token);
    // console.log('redirect: ' + redirectUrl);
    // console.log('attemptedUrl: ' + this.authService.attemptedUrl);
    if (token) {
      this.spinner.show();
      let url = this.authService.attemptedUrl || redirectUrl || '/';

      // Drop ONLY the single-use ?token= from the destination. If we forward it, the destination's
      // AppAuthorizeGuard sees the token, bounces back to /auth-return, and re-validates the
      // already-consumed SSO token -> second validation fails and login hangs.
      //
      // Everything else in the query string must survive: the CLE out-of-state exemption page is
      // addressed by Bar_Number + Year/PeriodStart, and the earlier "strip the whole query string"
      // sent a freshly signed-in attorney to that page with no parameters -> "Missing required
      // information" (CLE-OOS work order, Step 0.4 / Part A).
      url = AuthReturnComponent.stripTokenParam(url);
      if (!url || url.includes('auth-return')) {
        url = '/';
      }

      this.authService.clearUser();
      this.ssoService.ValidateToken(token)
        .pipe(take(1))
        .subscribe(resp => {
          this.spinner.hide();
          this.authService.token = resp.token;
          this.authService.user = resp.user;
          this.router.navigateByUrl(url);
        }, error => {
          console.log('validate token error: ' + JSON.stringify(error));
          this.router.navigate(['/unauthorized']);
        })


    } else {
      console.log('no token');
      this.router.navigate(['/']);
    }
  }

  ngOnDestroy(): void {
    this.spinner.hide();
  }

  /** Removes the `token` query parameter from a URL and keeps every other parameter in place. */
  static stripTokenParam(url: string): string {
    const q = url.indexOf('?');
    if (q < 0) {
      return url;
    }
    const params = new URLSearchParams(url.substring(q + 1));
    params.delete('token');
    const rest = params.toString();
    return url.substring(0, q) + (rest ? '?' + rest : '');
  }

}
